<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
          <div class="col-md-12">
              <div class="top-list-small-toolbar">
                  <div>
                    <h4 class="text-primary">Arus Stock</h4>
                    <div class="form-inline">
                        <div class="button-group">
                            <v-select :options="getProductSelect" :reduce="product => product.meta.code" label="product" v-model="product_no" class="vsc-custom vsc-custom-inline"/>
                        </div>
                        <div class="button-group">
                            <span><b>Company:</b> </span>
                            <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                              <option value="">-- All --</option>
                              <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                        </div>
                        <div class="button-group ml-1">
                            <span class="mr-1"><b>Date:</b> </span>
                            <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                        </div>
                        <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        <button data-toggle="modal" data-target="#modalProductCostList" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-soft-primary btn-sm" ><i class="fa fa-search" aria-hidden="true"></i> Sync</button>
                        <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-print" aria-hidden="true"></i> Print</button>
                        <div class="dropdown-menu" aria-labelledby="print">
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-12">
              <div class="card">
                  <div class="card-body">
                      <div class="table-responsive">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#summary-group" data-toggle="tab" aria-expanded="false" class="nav-link active">Group</a></li>
                            <li class="nav-item"><a href="#summary" data-toggle="tab" aria-expanded="false" class="nav-link">Data</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="summary-group">
                              <div class="table-responsive">
                                <span class="pull-right ml-2"><i>End Saldo: <b>{{ lastSaldo.qty | currency }} {{ lastSaldo.uom_id }}</b> ({{ lastSaldo.saldo | currency}})</i></span>
                                <span class="pull-right ml-2"><i>Start Saldo: <b>{{ startSaldo.qty | currency }} {{ startSaldo.uom_id }}</b></i></span>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <tr>
                                      <th style="background-color: #244854; color: white;" class="text-center"></th>
                                      <th colspan="5" class="text-center" style="background-color: #1A1A2E; color: white;">Masuk</th>
                                      <th colspan="5" class="text-center" style="background-color: #3d3d75; color: white;">Keluar</th>
                                      <th colspan="4" class="text-center" style="background-color: #6092a3; color: white;">Saldo</th>
                                    </tr>
                                    <tr>
                                      <th style="background-color: #244854; color: white;" class="text-center">Date</th>
                                      <!-- Stock Masuk -->
                                      <th style="background-color: #1A1A2E; color: white;">Status</th>
                                      <th style="background-color: #1A1A2E; color: white;">Qty</th>
                                      <th style="background-color: #1A1A2E; color: white;">Uom</th>
                                      <th style="background-color: #1A1A2E; color: white;">Ref No</th>
                                      <th style="background-color: #1A1A2E; color: white;">Vendor</th>
                                      <!-- Stock Keluar -->
                                      <th style="background-color: #3d3d75; color: white;">Status</th>
                                      <th style="background-color: #3d3d75; color: white;">Qty</th>
                                      <th style="background-color: #3d3d75; color: white;">Uom</th>
                                      <th style="background-color: #3d3d75; color: white;">Ref No</th>
                                      <th style="background-color: #3d3d75; color: white;">Customer</th>
                                      <!-- Stock Saldo -->
                                      <th style="background-color: #6092a3; color: white;">Qty</th>
                                      <th style="background-color: #6092a3; color: white;">Uom</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="d in groupCostSortOut" :key="d.id">
                                      <td>{{ d.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>
                                        <span class="badge badge-primary" v-if="d.statusIn === 'inventory'">{{ d.statusIn }}</span>
                                        <span class="badge badge-success" v-else-if="d.statusIn === 'purchasing'">{{ d.statusIn }}</span>
                                        <span class="badge badge-warning" v-else>{{ d.statusIn }}</span>
                                      </td>
                                      <td><span v-if="d.qtyIn !== 0">{{ d.qtyIn | currency }}</span></td>
                                      <td>{{ d.uomIn }}</td>
                                      <td>
                                        <span v-if="d.statusIn === 'inventory'" style="color: blue; cursor: pointer;" @click="showInventoryNo(d.refNoIn)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'adjust'" style="color: blue; cursor: pointer;" @click="showInventoryNo(d.refNoIn)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'retur sales'" style="color: blue; cursor: pointer;" @click="showReturSales(d.refNoIn)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'convert in'" style="color: blue; cursor: pointer;">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'purchasing'" style="color: blue; cursor: pointer;" @click="showPurchasingNo(d.refNoIn)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'onhand'" style="color: blue; cursor: pointer;">{{ d.refNoIn }}</span>
                                      </td>
                                      <td>{{ d.vendor }}</td>
                                      <td>
                                        <span class="badge badge-primary" v-if="d.statusOut === 'sales'">{{ d.statusOut }}</span>
                                        <span class="badge badge-success" v-else-if="d.statusOut === 'manufacture material'">{{ d.statusOut }}</span>
                                        <span class="badge badge-warning" v-else-if="d.statusOut === 'onhand'">{{ d.statusOut }}</span>
                                      </td>
                                      <td><span v-if="d.qtyOut !== 0">{{ d.qtyOut | currency }}</span></td>
                                      <td>{{ d.uomOut }}</td>
                                      <td>
                                        <span v-if="d.statusOut === 'manufacture material'" style="color: blue; cursor: pointer;" @click="showManufactureNo(d.refNoOut)" data-toggle="modal" data-target="#modalManufactureForm" data-backdrop="static" data-keyboard="false">{{ d.refNoOut }}</span>
                                        <span v-else-if="d.statusOut === 'sales'" style="color: blue; cursor: pointer;" @click="showSaleNo(d.refNoOut)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ d.refNoOut }} </span>
                                        <span v-else-if="d.statusOut === 'convert out'" style="color: blue; cursor: pointer;">{{ d.refNoOut }} </span>
                                        <span v-else-if="d.statusOut === 'retur purchasing'" style="color: blue; cursor: pointer;" @click="showReturPuchasing(d.refNoOut)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ d.refNoOut }} </span>
                                        <span v-else-if="d.statusOut === 'onhand'" style="color: blue; cursor: pointer;">{{ d.refNoOut }} </span>
                                        <span v-else-if="d.statusOut === 'adjust decrease'" style="color: blue; cursor: pointer;" @click="showInventoryNo(d.refNoOut)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ d.refNoOut }} </span>
                                      </td>
                                      <td>{{ d.customer }}</td>
                                      <td>{{ d.qtySaldo | currency }}</td>
                                      <td>{{ d.uomSaldo }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="summary">
                              <div class="table-responsive">
                                <span class="pull-right ml-2"><i>End Saldo: <b>{{ lastSaldo.qty | currency }} {{ lastSaldo.uom_id }}</b> ({{ lastSaldo.saldo | currency}})</i></span>
                                <span class="pull-right ml-2"><i>Start Saldo: <b>{{ startSaldo.qty | currency }} {{ startSaldo.uom_id }}</b></i></span>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <tr>
                                      <th style="background-color: #244854; color: white;" class="text-center"></th>
                                      <th colspan="6" class="text-center" style="background-color: #1A1A2E; color: white;">Masuk</th>
                                      <th colspan="6" class="text-center" style="background-color: #3d3d75; color: white;">Keluar</th>
                                      <th colspan="3" class="text-center" style="background-color: #6092a3; color: white;">Saldo</th>
                                    </tr>
                                    <tr>
                                      <th style="background-color: #244854; color: white;" class="text-center">Date</th>
                                      <!-- Stock Masuk -->
                                      <th style="background-color: #1A1A2E; color: white;">Status</th>
                                      <th style="background-color: #1A1A2E; color: white;">Qty</th>
                                      <th style="background-color: #1A1A2E; color: white;">Uom</th>
                                      <th style="background-color: #1A1A2E; color: white;">Ref No</th>
                                      <th style="background-color: #1A1A2E; color: white;">Vendor</th>
                                      <th style="background-color: #1A1A2E; color: white;">Total</th>
                                      <!-- Stock Keluar -->
                                      <th style="background-color: #3d3d75; color: white;">Status</th>
                                      <th style="background-color: #3d3d75; color: white;">Qty</th>
                                      <th style="background-color: #3d3d75; color: white;">Uom</th>
                                      <th style="background-color: #3d3d75; color: white;">Ref No</th>
                                      <th style="background-color: #3d3d75; color: white;">Customer</th>
                                      <th style="background-color: #3d3d75; color: white;">Total</th>
                                      <!-- Stock Saldo -->
                                      <th style="background-color: #6092a3; color: white;">Qty</th>
                                      <th style="background-color: #6092a3; color: white;">Uom</th>
                                      <th style="background-color: #6092a3; color: white;">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="d in groupCost" :key="d.id">
                                      <td>{{ d.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>
                                        <span class="badge badge-primary" v-if="d.statusIn === 'inventory'">{{ d.statusIn }}</span>
                                        <span class="badge badge-success" v-else-if="d.statusIn === 'purchasing'">{{ d.statusIn }}</span>
                                        <span class="badge badge-warning" v-else>{{ d.statusIn }}</span>
                                      </td>
                                      <td><span v-if="d.qtyIn !== 0">{{ d.qtyIn | currency }}</span></td>
                                      <td>{{ d.uomIn }}</td>
                                      <td>
                                        <span v-if="d.statusIn === 'inventory'" style="color: blue; cursor: pointer;" @click="showInventoryNo(d.refNoIn)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'adjust'" style="color: blue; cursor: pointer;" @click="showInventoryNo(d.refNoIn)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'retur sales'" style="color: blue; cursor: pointer;" @click="showReturSales(d.refNoIn)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'convert in'" style="color: blue; cursor: pointer;">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'purchasing'" style="color: blue; cursor: pointer;" @click="showPurchasingNo(d.refNoIn)" data-toggle="modal" data-target="#modalPurchasing" data-backdrop="static" data-keyboard="false">{{ d.refNoIn }}</span>
                                        <span v-else-if="d.statusIn === 'onhand'" style="color: blue; cursor: pointer;">{{ d.refNoIn }}</span>
                                      </td>
                                      <td>{{ d.vendor }}</td>
                                      <td>
                                        <!-- <span v-if="d.priceIn !== 0">{{ d.qtyIn * d.priceIn | currency }}</span> -->
                                        <span v-if="d.priceIn !== 0">{{ d.totalIn | currency }}</span>
                                      </td>
                                      <td>
                                        <span class="badge badge-primary" v-if="d.statusOut === 'sales'">{{ d.statusOut }}</span>
                                        <span class="badge badge-success" v-else-if="d.statusOut === 'manufacture material'">{{ d.statusOut }}</span>
                                        <span class="badge badge-warning" v-else-if="d.statusOut === 'onhand'">{{ d.statusOut }}</span>
                                      </td>
                                      <td><span v-if="d.qtyOut !== 0">{{ d.qtyOut | currency }}</span></td>
                                      <td>{{ d.uomOut }}</td>
                                      <td>
                                        <span v-if="d.statusOut === 'manufacture material'" style="color: blue; cursor: pointer;" @click="showManufactureNo(d.refNoOut)" data-toggle="modal" data-target="#modalManufactureForm" data-backdrop="static" data-keyboard="false">{{ d.refNoOut }}</span>
                                        <span v-else-if="d.statusOut === 'sales'" style="color: blue; cursor: pointer;" @click="showSaleNo(d.refNoOut)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ d.refNoOut }} </span>
                                        <span v-else-if="d.statusOut === 'convert out'" style="color: blue; cursor: pointer;">{{ d.refNoOut }} </span>
                                        <span v-else-if="d.statusOut === 'retur purchasing'" style="color: blue; cursor: pointer;" @click="showReturPuchasing(d.refNoOut)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false">{{ d.refNoOut }} </span>
                                        <span v-else-if="d.statusOut === 'onhand'" style="color: blue; cursor: pointer;">{{ d.refNoOut }} </span>
                                        <span v-else-if="d.statusOut === 'adjust decrease'" style="color: blue; cursor: pointer;" @click="showInventoryNo(d.refNoOut)" data-toggle="modal" data-target="#modalInventoryForm" data-backdrop="static" data-keyboard="false">{{ d.refNoOut }} </span>
                                      </td>
                                      <td>{{ d.customer }}</td>
                                      <!-- <td><span v-if="d.priceOut !== 0">{{ d.qtyOut * d.priceOut | currency }}</span></td> -->
                                      <td><span v-if="d.priceOut !== 0">{{ d.totalOut | currency }}</span></td>
                                      <td>{{ d.qtySaldo | currency }}</td>
                                      <td>{{ d.uomSaldo }}</td>
                                      <td>
                                        <!-- <span v-if="d.priceSaldo !== 0">{{ d.qtySaldo * d.priceSaldo | currency }}</span> -->
                                        <span v-if="d.priceSaldo !== 0">{{ d.totalSaldo | currency }}</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <InventoryFormModal/>
        <PurchasingModal />
        <SaleModal />
        <ManufactureFormModal />
        <ReturnModal />
        <ProductCostListModal @getSyncData="getSyncData"/>
        <div class="row">
          <!-- <div class="col-md-6"><pre>{{ groupCost }}</pre></div> -->
          <!-- <div class="col-md-6"><pre>{{ dataRaw }}</pre></div> -->
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { productUrl, report2Url, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import InventoryFormModal from '@/components/inventory/InventoryFormModal.vue'
import PurchasingModal from '@/components/purchasing/PurchasingModal.vue'
import SaleModal from '@/components/sales/SaleModal.vue'
import ManufactureFormModal from '@/components/manufacture/ManufactureFormModal.vue'
import ReturnModal from '@/components/return/ReturnModal.vue'
import ProductCostListModal from '@/components/product/ProductCostListModal.vue'

export default {
  name: 'ProductStockFlow',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    InventoryFormModal,
    PurchasingModal,
    SaleModal,
    ManufactureFormModal,
    ReturnModal,
    ProductCostListModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      startSaldo: {
        qty: 0,
        saldo: 0,
        uom_id: null
      },
      uom: null,
      company_no: null,
      product_no: null,
      filterCompany: [],
      startDate: [date1, date2],
      dateNow: new Date(),
      company: null,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type',
        align: 'text-left'
      }, {
        name: 'Queue',
        prop: 'queue',
        align: 'text-left'
      }, {
        name: 'Queue Saldo',
        prop: 'queue_saldo',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'cost_date',
        align: 'text-left'
      }, {
        name: 'Ref No.',
        prop: 'ref_no',
        align: 'text-left'
      }, {
        name: 'Vendor',
        prop: 'vendor',
        align: 'text-left'
      }, {
        name: 'Customer',
        prop: 'customer',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'qty',
        align: 'text-right'
      }, {
        name: 'Uom',
        prop: 'uom_id',
        align: 'text-left'
      }, {
        name: 'Price',
        prop: 'price',
        align: 'text-right'
      }, {
        name: 'Avg. COGS',
        prop: 'cost_average',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getProductListSelect')
    if (window.localStorage.getItem('authUser')) {
      const authU = window.localStorage.getItem('authUser')
      const auth = JSON.parse(authU)
      console.log('auth session')
      console.log(auth)
      this.company_no = auth.user.company_no
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      productListSelect: state => state.products.productListSelect,
      productCostByNo: state => state.products.productCostByNo,
      productUomByNo: state => state.products.productUomByNo
    }),
    lastSaldo () {
      var array = this.dataRaw
      var maxQueue = 0
      for (let i = 0; i < array.length; i++) {
        maxQueue = array[i].queue
      }
      var arr = array.filter(d => d.status === 'current').filter(d => d.queue === maxQueue)
      var totalQty = 0
      var totalSaldo = 0
      var uomId = null
      for (let a = 0; a < arr.length; a++) {
        totalQty += parseFloat(arr[a].cost_qty)
        totalSaldo += parseFloat(arr[a].cost_qty) * parseFloat(arr[a].cost_amount)
        uomId = arr[a].uom_id
      }
      var obj = {
        qty: totalQty,
        saldo: totalSaldo,
        uom_id: uomId
      }
      return obj
    },
    totalQtyIn () {
      var sum = 0
      var array = this.groupCost
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qtyIn)
      }
      return sum
    },
    totalQtyOut () {
      var sum = 0
      var array = this.groupCost
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qtyOut)
      }
      return sum
    },
    totalQtySaldo () {
      var sum = 0
      var array = this.groupCost
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qtySaldo)
      }
      return sum
    },
    companyData () {
      var obj = {
        name: null,
        address: null,
        phone: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address,
          phone: cmp.phone
        }
      }
      return obj
    },
    getProductSelect () {
      var array = this.productListSelect
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: '[' + array[i].product_no + '] ' + array[i].product_name,
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    groupCostSortOut () {
      var result = []
      if (this.groupCost.length > 0) {
        this.groupCost.reduce(function (res, value) {
          var key = null
          if (value.refNoOut === null) {
            key = value.refNoIn
          } else {
            key = value.refNoOut
          }
          if (!res[key]) {
            res[key] = {
              date: value.date,
              qtyIn: parseFloat(value.qtyIn),
              uomIn: value.uomIn,
              refNoIn: value.refNoIn,
              statusIn: value.statusIn,
              vendor: value.vendor,
              qtyOut: parseFloat(value.qtyOut),
              uomOut: value.uomOut,
              refNoOut: value.refNoOut,
              statusOut: value.statusOut,
              customer: value.customer,
              qtySaldo: parseFloat(value.qtySaldo),
              uomSaldo: value.uomSaldo
            }
            result.push(res[key])
          } else {
            res[key].qtyIn = parseFloat(res[key].qtyIn) + parseFloat(value.qtyIn)
            res[key].qtyOut = parseFloat(res[key].qtyOut) + parseFloat(value.qtyOut)
            res[key].qtySaldo = parseFloat(value.qtySaldo)
            res[key].uomSaldo = value.uomSaldo
          }
          return res
        }, {})
      }
      return result
    },
    groupCost () {
      var result = []
      if (this.dataRaw.length > 0) {
        this.dataRaw.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.company_no + value.queue
          if (!res[key]) {
            console.log(key)
            var qtyIn = 0
            var qtyOut = 0
            var qtySaldo = 0
            var uomIn = null
            var uomOut = null
            var uomSaldo = null
            var priceIn = 0
            var priceOut = 0
            var priceSaldo = 0
            var refNoIn = null
            var refNoOut = null
            var statusIn = null
            var statusOut = null
            var vendor = null
            var customer = null
            var totalIn = 0
            var totalOut = 0
            var totalSaldo = 0
            var out = []
            var saldo = []
            if (value.type === 'in') {
              qtyIn = value.cost_qty
              uomIn = value.uom_id
              priceIn = value.cost_amount
              refNoIn = value.ref_no
              statusIn = value.status
              vendor = value.purchasing.vendor
              totalIn = parseFloat(value.cost_qty) * parseFloat(value.cost_amount)
            } else if (value.type === 'out') {
              qtyOut = value.cost_qty
              uomOut = value.uom_id
              priceOut = value.cost_amount
              customer = value.sales.customer
              refNoOut = value.ref_no
              statusOut = value.status
              out.push({
                qtyOut: value.cost_qty,
                uomOut: value.uom_id,
                priceOut: value.cost_amount,
                refNoOut: value.ref_no,
                customer: value.sales.customer,
                status: value.status,
                notes: value.notes
              })
              totalOut = parseFloat(value.cost_qty) * parseFloat(value.cost_amount)
            } else if (value.type === 'saldo') {
              qtySaldo = value.cost_qty
              uomSaldo = value.uom_id
              priceSaldo = value.cost_average
              saldo.push({
                qtySaldo: value.cost_qty,
                uomSaldo: value.uom_id,
                priceSaldo: value.cost_average,
                refNoSaldo: value.ref_no,
                status: value.status,
                queue_saldo: value.queue_saldo,
                notes: value.notes
              })
              totalSaldo = parseFloat(value.cost_qty) * parseFloat(value.cost_average)
            }
            res[key] = {
              date: value.cost_date,
              qtyIn: qtyIn,
              uomIn: uomIn,
              priceIn: priceIn,
              refNoIn: refNoIn,
              statusIn: statusIn,
              vendor: vendor,
              totalIn: totalIn,
              qtyOut: qtyOut,
              uomOut: uomOut,
              priceOut: priceOut,
              refNoOut: refNoOut,
              statusOut: statusOut,
              customer: customer,
              out: out,
              totalOut: totalOut,
              qtySaldo: qtySaldo,
              uomSaldo: uomSaldo,
              priceSaldo: priceSaldo,
              saldo: saldo,
              totalSaldo: totalSaldo
            }
            result.push(res[key])
          } else {
            if (value.type === 'in') {
              res[key].qtyIn = parseFloat(res[key].qtyIn) + parseFloat(value.cost_qty)
              res[key].priceIn = value.cost_amount
              res[key].uomIn = value.uom_id
              res[key].refNoIn = value.ref_no
              res[key].statusIn = value.status
              if (value.status === 'inventory') {
                res[key].vendor = value.inventory.vendor
              } else {
                res[key].vendor = value.purchasing.vendor
              }
              res[key].totalIn += parseFloat(value.cost_qty) * parseFloat(value.cost_amount)
            } else if (value.type === 'out') {
              res[key].qtyOut = parseFloat(res[key].qtyOut) + parseFloat(value.cost_qty)
              res[key].priceOut = value.cost_amount
              res[key].uomOut = value.uom_id
              res[key].refNoOut = value.ref_no
              res[key].statusOut = value.status
              res[key].customer = value.sales.customer
              res[key].out.push({
                qtyOut: value.cost_qty,
                uomOut: value.uom_id,
                priceOut: value.cost_amount,
                refNoOut: value.ref_no,
                customer: value.sales.customer,
                status: value.status,
                notes: value.notes
              })
              res[key].totalOut += parseFloat(value.cost_qty) * parseFloat(value.cost_amount)
            } else if (value.type === 'saldo') {
              res[key].qtySaldo = parseFloat(res[key].qtySaldo) + parseFloat(value.cost_qty)
              res[key].uomSaldo = value.uom_id
              res[key].priceSaldo = value.cost_average
              res[key].saldo.push({
                qtySaldo: value.cost_qty,
                uomSaldo: value.uom_id,
                priceSaldo: value.cost_average,
                refNoSaldo: value.ref_no,
                status: value.status,
                queue_saldo: value.queue_saldo,
                notes: value.notes
              })
              res[key].totalSaldo += parseFloat(value.cost_qty) * parseFloat(value.cost_average)
            }
          }
          return res
        }, {})
      }
      // return result
      var col = 'date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    groupCost2 () {
      var result = []
      if (this.dataRaw.length > 0) {
        this.dataRaw.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.company_no + value.queue
          if (!res[key]) {
            console.log(key)
            var qtyIn = 0
            var qtyOut = 0
            var qtySaldo = 0
            var uomIn = null
            var uomOut = null
            var uomSaldo = null
            var priceIn = 0
            var priceOut = 0
            var priceSaldo = 0
            var refNoIn = null
            var refNoOut = null
            var statusIn = null
            var statusOut = null
            var vendor = null
            var customer = null
            var out = []
            var saldo = []
            if (value.type === 'in') {
              qtyIn = value.cost_qty
              uomIn = value.uom_id
              priceIn = value.cost_amount
              refNoIn = value.ref_no
              statusIn = value.status
              vendor = value.purchasing.vendor
            } else if (value.type === 'out') {
              qtyOut = value.cost_qty
              uomOut = value.uom_id
              priceOut = value.cost_amount
              customer = value.sales.customer
              refNoOut = value.ref_no
              statusOut = value.status
              out.push({
                qtyOut: value.cost_qty,
                uomOut: value.uom_id,
                priceOut: value.cost_amount,
                refNoOut: value.ref_no,
                customer: value.sales.customer,
                status: value.status,
                notes: value.notes
              })
            } else if (value.type === 'saldo') {
              qtySaldo = value.cost_qty
              uomSaldo = value.uom_id
              priceSaldo = value.cost_average
              saldo.push({
                qtySaldo: value.cost_qty,
                uomSaldo: value.uom_id,
                priceSaldo: value.cost_average,
                refNoSaldo: value.ref_no,
                status: value.status,
                queue_saldo: value.queue_saldo,
                notes: value.notes
              })
            }
            res[key] = {
              date: value.cost_date,
              qtyIn: qtyIn,
              uomIn: uomIn,
              priceIn: priceIn,
              refNoIn: refNoIn,
              statusIn: statusIn,
              vendor: vendor,
              qtyOut: qtyOut,
              uomOut: uomOut,
              priceOut: priceOut,
              refNoOut: refNoOut,
              statusOut: statusOut,
              customer: customer,
              out: out,
              qtySaldo: qtySaldo,
              uomSaldo: uomSaldo,
              priceSaldo: priceSaldo,
              saldo: saldo
            }
            result.push(res[key])
          } else {
            if (value.type === 'in') {
              res[key].qtyIn = parseFloat(res[key].qtyIn) + parseFloat(value.cost_qty)
              res[key].priceIn = value.cost_amount
              res[key].uomIn = value.uom_id
              res[key].refNoIn = value.ref_no
              res[key].statusIn = value.status
              if (value.status === 'inventory') {
                res[key].vendor = value.inventory.vendor
              } else {
                res[key].vendor = value.purchasing.vendor
              }
            } else if (value.type === 'out') {
              res[key].qtyOut = parseFloat(res[key].qtyOut) + parseFloat(value.cost_qty)
              res[key].priceOut = value.cost_amount
              res[key].uomOut = value.uom_id
              res[key].refNoOut = value.ref_no
              res[key].statusOut = value.status
              res[key].customer = value.sales.customer
              res[key].out.push({
                qtyOut: value.cost_qty,
                uomOut: value.uom_id,
                priceOut: value.cost_amount,
                refNoOut: value.ref_no,
                customer: value.sales.customer,
                status: value.status,
                notes: value.notes
              })
            } else if (value.type === 'saldo') {
              res[key].qtySaldo = parseFloat(res[key].qtySaldo) + parseFloat(value.cost_qty)
              res[key].uomSaldo = value.uom_id
              res[key].priceSaldo = value.cost_average
              res[key].saldo.push({
                qtySaldo: value.cost_qty,
                uomSaldo: value.uom_id,
                priceSaldo: value.cost_average,
                refNoSaldo: value.ref_no,
                status: value.status,
                queue_saldo: value.queue_saldo,
                notes: value.notes
              })
            }
          }
          return res
        }, {})
      }
      // return result
      var col = 'date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async getProductNo (value) {
      this.product_no = value.product_no
      var date = new Date(value.date)
      this.startDate = [date, date]
      await this.refreshList()
    },
    async showReturPuchasing (no) {
      var payload = {
        return_no: no
      }
      this.$store.commit('SET_RETURN_BY_NO', payload)
      this.$store.dispatch('getReturnByNo', payload)
    },
    async getSyncData (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      var date = new Date(value.date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        date: newDate,
        product_no: this.product_no,
        type: 'all',
        company_no: this.company_no
      }
      console.log(obj)
      await axios.post(productUrl + '/cost/sync', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    showReturSales (no) {
      var payload = {
        return_no: no
      }
      this.$store.commit('SET_RETURN_BY_NO', payload)
      this.$store.dispatch('getReturnByNo', payload)
    },
    getCOGS (product, company) {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var payload = {
        begin: begin,
        end: end,
        product_no: product,
        company_no: company
      }
      console.log(payload)
      this.company = company
      this.$store.dispatch('getProductCogsByNo', payload)
    },
    async setCOGS () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        const detail = this.dataRaw.find(d => d.id === array[i])
        var data = {
          date: detail.purchasing_date,
          product_no: detail.product_no,
          type: 'all',
          company_no: detail.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response.data.message)
            this.$swal('Error', error.response.data.message + '[' + detail.product_no + ']', 'error')
            this.$Progress.finish()
            this.loader.isLoading = false
            throw error
          })
      }
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        this.selected = []
        this.selectAll = false
        await this.$swal('Success', resp.message, 'success')
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    showManufactureNo (no) {
      var payload = {
        manufacture_no: no
      }
      this.$store.commit('SET_MANUFACTURE_BY_NO', payload)
      this.$store.dispatch('getManufactureByNo', payload)
    },
    showInventoryNo (no) {
      var payload = {
        inventory_no: no
      }
      this.$store.commit('SET_INVENTORY_BY_NO', payload)
      this.$store.dispatch('getInventoryByNo', payload)
    },
    showPurchasingNo (no) {
      var payload = {
        purchasing_no: no
      }
      this.$store.commit('SET_PURCHASING_ID', payload)
      this.$store.dispatch('getPurchasingShowByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        product_no: this.product_no,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(productUrl + '/cost/get-product')
      await axios.post(productUrl + '/cost/get-product', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
          if (this.product_no !== null) {
            var payload = {
              product_no: this.product_no
            }
            this.$store.dispatch('getProductUomByNo', payload)
            var prdSelect = this.getProductSelect.find(d => d.product_no === this.product_no)
            console.log(prdSelect)
            this.uom = prdSelect ? prdSelect.uom_id : null
          }
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error', error.message, 'error')
          throw error
        })
      var payload = {
        product_no: this.product_no
      }
      await this.$store.dispatch('getProductCogsByNo', payload)
      var now = new Date(begin)
      var yesterday = now.setDate(now.getDate() - 1)
      var body = {
        product_no: this.product_no,
        date: new Date(yesterday),
        company_no: this.company_no
      }
      console.log('body saldo: ')
      console.log(body)
      await axios.post(productUrl + '/cost/get-saldo', body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.startSaldo = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response.data.message)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.groupCostSortOut
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await axios.post(report2Url + '/stock-flow', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>
